import { createSuspenseQuery } from "@steto-care/steto-query";

import { PatientRepository } from "@/io/repository/PatientRepository.ts";

export class PatientQueries {
  constructor(private readonly repository: PatientRepository = new PatientRepository()) {}

  useMe = createSuspenseQuery(
    "use-me",
    ({}) => [],
    async () => this.repository.getMe(),
  );
}
